import axios from "axios";
import { gettoken } from "../../../../shared/services/token/token";
import apiurl from "../apiendpoint/apiendpoint";

export const apisaveCurrentaffairs = async (datas) => {
    try {
        const token = gettoken();
        const res = await axios.post(`${apiurl()}/currentaffairs/apisavecurrentaffairs`, datas, { headers: { "Authorization": `Bearer ${token}`}});

        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetallCurrentaffairs = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetallcurrentaffairs`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apiupdateCurrentaffairs = async (_id,datas) => {
    try {
        const token = gettoken();
        const res = await axios.put(`${apiurl()}/currentaffairs/apiupdatecurrentaffairs/${_id}`, datas,{headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apideleteCurrentaffairs = async (_id) => {
    try {
        const token = gettoken();
        const res = await axios.delete(`${apiurl()}/currentaffairs/apideletecurrentaffairs/${_id}`,{headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};